import type { Bytes } from "../types/Units"
import { ResponseHeader } from "./ResponseHeader"

export const ResponseContentLength = (
  r: Request | Response | XMLHttpRequest
): Bytes => {
  // supports both fetch and xhttp

  const h = ResponseHeader(r, "content-length", "0")

  try {
    return parseInt(h) as Bytes
  } catch {
    return 0 as Bytes
  }
}
